import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-weely-rental',
  templateUrl: './weely-rental.component.html',
  styleUrls: ['./weely-rental.component.css']
})
export class WeelyRentalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
